export const FEEDBACK_SUBJECT_EMPTY = "";

export type FeedbackIssueTypeSlug =
  | "posting_ad"
  | "login"
  | "registration"
  | "technical_error"
  | "other_feedback"
  | "business_info_changes"
  | "new_customer";

export interface FeedbackSubjectOption {
  value: FeedbackIssueTypeSlug;
  i18nKey: string;
}

export const CONSUMER_SUBJECT_OPTIONS: FeedbackSubjectOption[] = [
  {
    value: "posting_ad",
    i18nKey: "feedbackForm.subjectOptions.consumer.postingAd"
  },
  { value: "login", i18nKey: "feedbackForm.subjectOptions.consumer.login" },
  {
    value: "registration",
    i18nKey: "feedbackForm.subjectOptions.consumer.registration"
  },
  {
    value: "technical_error",
    i18nKey: "feedbackForm.subjectOptions.technicalError"
  },
  {
    value: "other_feedback",
    i18nKey: "feedbackForm.subjectOptions.consumer.otherFeedback"
  }
];

export const DEALER_SUBJECT_OPTIONS: FeedbackSubjectOption[] = [
  {
    value: "business_info_changes",
    i18nKey: "feedbackForm.subjectOptions.dealer.businessInfoChanges"
  },
  {
    value: "technical_error",
    i18nKey: "feedbackForm.subjectOptions.dealer.technicalError"
  },
  {
    value: "new_customer",
    i18nKey: "feedbackForm.subjectOptions.dealer.newCustomer"
  },
  {
    value: "other_feedback",
    i18nKey: "feedbackForm.subjectOptions.dealer.otherFeedback"
  }
];
